import {
   useMutation,
   MutationFunction,
   UseMutationOptions
} from '@tanstack/react-query'

import {
   API_INITIAL,
   API_FETCHING,
   API_SUCCESS,
   API_FAILED,
   APIStatus
} from '@flowwai-frontend/shared/api-common'

type Props<TData, TError, TVariables> = Omit<
   UseMutationOptions<TData, TError, TVariables>,
   'mutationFn'
>

interface Callbacks<TData, TError> {
   onSuccess?: (data: TData) => void
   onError?: (error: TError) => void
}

//TODO: need to handle types without any and unknown type
const useAsync = <TData, TError extends Error, TRequestObj>(
   getDataAPI: MutationFunction<TData, TRequestObj>,
   props?: Props<TData, TError, TRequestObj>
) => {
   const { mutate, mutateAsync, ...other } = useMutation(getDataAPI, props)

   const getAPIStatus = (): APIStatus => {
      const { isLoading, isError, isSuccess } = other

      if (isLoading) return API_FETCHING
      if (isSuccess) return API_SUCCESS
      if (isError) return API_FAILED

      return API_INITIAL
   }

   const triggerAsyncAPI = async (
      requestObject: TRequestObj,
      callbacks: Callbacks<TData, TError>
   ) => {
      const { onError, onSuccess } = callbacks
      let data
      try {
         await mutateAsync(requestObject).then((response: TData) => {
            data = response
            onSuccess && onSuccess(response)
         })

         return data
      } catch (error) {
         onError && onError(error as any) //TODO: Need to handle types properly here
      }
      return data
   }

   return {
      ...other,
      triggerAPI: mutate,
      triggerAsyncAPI: triggerAsyncAPI,
      apiStatus: getAPIStatus(),
      mutateAsync
   }
}

export { useAsync }
